/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc
 */
import * as References from './ApplicationInstallsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#uninstallApp
 */
export const UNINSTALL_APP_MUTATION_FIELD_NAME = 'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_uninstallApp';
export const UNINSTALL_APP_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNINSTALL_APP_MUTATION_FIELD_NAME,
  args: ['appId', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.uninstallAppRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#getUserInstallInfos
 */
export const GET_USER_INSTALL_INFOS_QUERY_FIELD_NAME = 'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_getUserInstallInfos';
export const GET_USER_INSTALL_INFOS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_USER_INSTALL_INFOS_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getUserInstallInfosRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.application.installs.rpc.ApplicationInstallsRpc#uninstallAppForUser
 */
export const UNINSTALL_APP_FOR_USER_MUTATION_FIELD_NAME = 'com_hubspot_application_installs_rpc_ApplicationInstallsRpc_uninstallAppForUser';
export const UNINSTALL_APP_FOR_USER_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: UNINSTALL_APP_FOR_USER_MUTATION_FIELD_NAME,
  args: ['appId', 'userId', 'businessUnitId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.uninstallAppForUserRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});